import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { PutPolicyFailure, PutPolicyRequest, PutPolicyReset, PutPolicySuccess } from './actions';
import { HomePolicy } from '@models/swagger';

export const featureKey = 'putPolicy';

export interface State {
  data: HomePolicy | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(PutPolicyFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(PutPolicyRequest, state => ({ ...state, error: null, loading: true })),
    on(PutPolicySuccess, (state, { data }) => ({ ...state, data, error: null, loading: false })),
    on(PutPolicyReset, state => ({ ...state, data: null, error: null, loading: false }))
  )(state, action);
}
